import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { IMaskInput } from 'react-imask';

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const slideUp = keyframes`
  from { transform: translateY(12px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(5, 7, 12, 0.5);
  z-index: 1001;
  animation: ${fadeIn} 160ms ease-out both;
`;

export const ModalShell = styled.div`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  z-index: 1002;
  display: grid;
  place-items: center;
  pointer-events: none;
`;

export const Dialog = styled.div`
  width: calc(100% - 32px);
  max-width: 480px;
  pointer-events: auto;
  animation: ${slideUp} 200ms ease-out both;
`;

export const PageTitle = styled.span`
  color: #e9ecf5;
  font-size: 18px;
  font-family: Inter;
  font-weight: 600;
  line-height: 25.2px;
  word-wrap: break-word;
`;

export const CardPlanDetails = styled.div`
  display: flex;
  padding: 12px;
  background: #1e1f22;
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  flex-direction: column;
  gap: 12px;
`;

export const CardDetailTitle = styled.span`
  color: #e9ecf5;
  font-size: 17px;
  font-family: Inter;
  font-weight: 600;
  line-height: 140%;
  word-wrap: break-word;
`;

export const CardDetailsDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardDetailDescText = styled.span`
  color: #e9ecf5;
  font-size: 16px;
  font-family: Inter;
  font-weight: 500;
  line-height: 22.4px;
  word-wrap: break-word;
`;

export const CardDetailHighlight = styled.span`
  color: #8fb0ff;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const Divider = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 1px #2b2d33 solid;
  outline-offset: -0.5px;
`;

export const PaymmentMethodTitle = styled.span`
  color: #e9ecf5;
  font-size: 17px;
  font-family: Inter;
  font-weight: 600;
  line-height: 140%;
  word-wrap: break-word;
`;

export const PaymentButton = styled.span`
  display: flex;
  height: 44px;
  min-height: 44px;
  padding: 12px;
  background: #00d66f;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  color: black;
  font-size: 17px;
  font-family: Inter;
  font-weight: 600;
  line-height: 23.8px;
  word-wrap: break-word;
`;

export const CreditCards = styled.img`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 83px;
  height: 15px;
`;

export const HalfInputsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const HalfInputWrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  gap: 4px;
`;

export const DisclaimerText = styled.span`
  color: #8e96a8;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 21px;
  word-wrap: break-word;
`;

export const ImaskInputStyled = styled(IMaskInput)`
  width: 100%;
  background: #23252A;
  color: #E9ECF5;
  border: 2px solid #23252A;
  border-radius: 12px;
  padding: 12px;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.2;
  box-sizing: border-box;
  max-height: 44px;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &::focus: {
    outline: 'none',
    borderColor: '#98B3FF',
    boxShadow: 'inset 0 0 0 1px #98B3FF',
  },
  &::placeholder: { color: '#7D8493' },

  &.error {
    outline: 2px #D65F46 solid;
    outline-offset: -2px;
  }
`;
